'use client';
import React, { FC, ReactNode } from 'react';

export type ButtonProps = {
  children: ReactNode; // 子元素，可以是文本或其他React节点
  onClick?: () => void; // 可选的点击事件
  className?: string; // 可选的额外类名
  disabled?: boolean; // 是否禁用按钮
  type?: 'button' | 'submit' | 'reset' | 'primary' | 'gradual' | 'link'; // 按钮类型
  size?: 'sm' | 'md' | 'lg'; // 按钮大小
  color?: string; // 颜色
  paddingTop?: string;
  paddingLeft?: string;
  paddingRight?: string;
  paddingBottom?: string;
  rounded?: string;
  font?: string;
  borderColor?: string;
};

// 定义Button组件，支持自定义文本、样式和点击事件
export const Button = (props: ButtonProps) => {
  const {
    children,
    onClick,
    className,
    disabled,
    type = 'button',
    size = 'md',
    color = 'primary',
    paddingTop = '3',
    paddingLeft = '1.5',
    paddingRight = '1.5',
    paddingBottom = '3',
    rounded = 'rounded-2xl',
    font = 'text-[13px]',
    borderColor = '',
  } = props;
  const newColor = borderColor === '' ? color : borderColor;
  const colorClasses = {
    primary: 'text-white bg-btn-green',
    gradual: 'bg-gradient-to-r from-lnd-start to-lnd-end',
    button: '',
    submit: '',
    reset: '',
    link: `border border-solid border-${newColor} text-${color}`,
  };

  const sizeClasses = {
    sm: `${font} font-normal pr-${paddingRight} pl-${paddingLeft} pt-${paddingTop} pb-${paddingBottom} ${rounded}`,
    md: `${font} font-normal pr-${paddingRight} pl-${paddingLeft} pt-${paddingTop} pb-${paddingBottom} ${rounded}`,
    lg: 'text-lg p-3 w-full rounded-3xl',
  };

  return (
    <button
      // @ts-ignore
      type={type} // 按钮类型（默认是'button'）
      className={`${sizeClasses[size]} ${colorClasses[type]} ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-700'} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
